import React from 'react';
import SessionTimer from '../session/SessionTimer';
import './PageHeader.css';

const PageHeader = ({
    title,
    subtitle,
    breadcrumbCurrent,
    actions,
    statsRow,
    filterRow,
    centerStat
}) => {
    return (
        <div className="app-page-header-card">
            {/* Top strip containing breadcrumb & session timer */}
            <div className="app-page-header-top-strip">
                <nav aria-label="Breadcrumb" className="breadcrumb">
                    <ol className="breadcrumb-list">
                        <li className="breadcrumb-item">
                            <a href="/dashboard" className="breadcrumb-link">
                                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" width="14" height="14">
                                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                                </svg>
                                Home
                            </a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="breadcrumb-separator" aria-hidden="true">
                                <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                </svg>
                            </span>
                            <span className="breadcrumb-current" aria-current="page">
                                {breadcrumbCurrent}
                            </span>
                        </li>
                    </ol>
                </nav>
                <div className="breadcrumb-session-timer">
                    <SessionTimer />
                </div>
            </div>

            {/* Main Header Content */}
            <div className="app-page-header-content">
                <div className={`app-page-header-main-row ${centerStat ? 'has-center-stat' : ''}`}>
                    <div className="title-section">
                        <h1>{title}</h1>
                        {subtitle && <p className="subtitle">{subtitle}</p>}
                    </div>
                    {centerStat && (
                        <div className="app-page-header-center-stat">
                            {centerStat}
                        </div>
                    )}
                    {actions && (
                        <div className="app-page-header-actions">
                            {actions}
                        </div>
                    )}
                </div>

                {statsRow && (
                    <div className="app-page-header-stats-row">
                        {statsRow}
                    </div>
                )}

                {filterRow && (
                    <div className="app-page-header-filter-row">
                        {filterRow}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PageHeader;
